import { useParams } from "react-router";
import Container from "../components/common/Container";
import styled from "styled-components";
import { Flex, Image } from "@mantine/core";
import CompanyDetailTable from "../components/CompanyDetail/Table";
import PageHeader from "../components/common/PageHeader";
import { useEffect, useState } from "react";
import { Company } from "../types/types";
import { getCompanyById, getCompanyPhoto } from "../api/companyApi";

const CompanyDetail = () => {
  const { id } = useParams();
  const [company, setCompany] = useState<Company>();
  const [companyLogo, setCompanyLogo] = useState<any>();

  useEffect(() => {
    const getList = async () => {
      try {
        const data: any = await getCompanyById(`${id}`);
        setCompany(data?.data?.company);
        try {
          const photo: any = await getCompanyPhoto(id, "hr");
          if (photo?.data) {
            const imgUrl = URL.createObjectURL(photo.data);
            setCompanyLogo(imgUrl);
          }
        } catch (e) {
          console.warn("Logo yüklenemedi");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    getList();
  }, []);

  return (
    <Container>
      <PageHeader title={"Şirket Detayları"} />
      <Flex mb={40} direction="row" align="center" gap={32}>
        <ImageWrapper>
          <Image
            style={{
              objectFit: "contain",
            }}
            src={companyLogo ? companyLogo : "/assets/logoPlaceholder.png"}
            alt="Ford Logo"
          />
        </ImageWrapper>
        <Flex gap={20} direction={"row"}>
          <Flex gap={3} direction={"column"}>
            <InfoTitle>Şirket Adı</InfoTitle>
            <InfoText>{company?.name}</InfoText>
          </Flex>
          <Flex gap={3} direction={"column"}>
            <InfoTitle>Şirket Kodu</InfoTitle>
            <InfoText>{company?.code}</InfoText>
          </Flex>
          <Flex gap={3} direction={"column"}>
            <InfoTitle>Şirket Adresi</InfoTitle>
            <InfoText>{company?.address}</InfoText>
          </Flex>
        </Flex>
      </Flex>
      <CompanyDetailTable />
    </Container>
  );
};

export default CompanyDetail;

const InfoTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: black;
`;

const InfoText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: black;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  height: 100px;
  width: 300px;
`;
